import i18next from 'i18next';
import en from './i18n/en';
import tr from './i18n/tr';
import ar from './i18n/ar';
import DownloadRates from './DownloadRates';

i18next.addResourceBundle('en', 'downloadRatesPage', en);
i18next.addResourceBundle('tr', 'downloadRatesPage', tr);
i18next.addResourceBundle('ar', 'downloadRatesPage', ar);

const DownloadRatesConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  routes: [
    {
      path: '/download-rates',
      component: DownloadRates
    }
  ]
};

export default DownloadRatesConfig;